import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'
import { createApp } from 'vue'

import 'leaflet/dist/leaflet.css'
import './styles.css'
import App from './App.vue'
import { router } from './router'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

createApp(App).use(router).use(VueQueryPlugin, { queryClient }).mount('#app')

/**
 * Production only, and dynamically imported so the virtual module never enters
 * the dev graph. A service worker in `npm run dev` shadows Vite's HMR with
 * stale assets, which costs far more time than it saves.
 *
 * `registerType` defaults to `autoUpdate`: a new worker skips waiting and the
 * page reloads once it activates. The app holds no unsaved state, so the worst
 * case is a re-render shortly after a deploy — cheaper than designing an
 * update-available prompt this app needs for nothing else.
 */
if (import.meta.env.PROD) {
  void import('virtual:pwa-register').then(({ registerSW }) => {
    registerSW({ immediate: true })
  })
}
